/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Completeness of the execution-quality capture set used by an aggregate.
 */
export enum CaptureCompleteness {

    Complete = 'complete',

    Partial = 'partial',

    Pending = 'pending',

    Empty = 'empty',

    Unknown = 'unknown'
}
